import { CSSProperties } from 'react';
import type { LayerType } from 'hooks/layerNode/types';

export const INPUT_STYLE = {
  width: '100%',
  backgroundColor: '#1f1f1f',
  color: '#e0e0e0',
  border: '1px solid #2c2c2c',
  borderRadius: '6px',
} as CSSProperties;

export type PointGeometry = { longitude: number; latitude: number };

export type DrawingUpdate =
  | { kind: 'point'; point: PointGeometry }
  | { kind: 'polyline'; points: PointGeometry[] };

export type InitialView = {
  center: [number, number];
  zoom: number;
  padding?: __esri.ViewPadding;
};

export const US_INITIAL_VIEW: InitialView = {
  center: [-100, 40],
  zoom: 4,
  padding: { left: 0, top: 0, right: 0, bottom: 0 },
};

export type OnAddLayer = (
  layerType: LayerType | 'dhs' | 'default' | 'openWeatherMap'
) => void;
